// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueDPlayer);
/* eslint-disable no-new */
new Vue({
  el: '#app',

  router,
  store,
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js